module.exports = __webpack_public_path__ + "img/8.924a7362.png";